// extracted by mini-css-extract-plugin
export var blue = "Y_cw";
export var dark = "Y_cF";
export var gold = "Y_cx";
export var gray = "Y_cy";
export var iconMain = "Y_cG";
export var light = "Y_cD";
export var magenta = "Y_cC";
export var none = "Y_cz";
export var orange = "Y_cB";
export var original = "Y_cv";
export var root = "Y_ct";
export var tan = "Y_cp";